import PropTypes from "prop-types";

export default {
  columns: PropTypes.array,
  userHasAccess: PropTypes.bool,
  settingsState: PropTypes.object,
  setSettingsState: PropTypes.func,
  lockedSettings: PropTypes.arrayOf(PropTypes.string)
};
